export enum TransformTypeEnum {
  UPPERCASE = 'uppercase',
  LOWERCASE = 'lowercase',
  CAMELCASE = 'camelcase',
  CAPITALIZE = 'capitalize',
}
